import { useState } from "react";
import { copyText } from "utils/util";
import CommonModal from "components/common/CommonModal";
import LocationDetail from "pages/location/LocationMap";
import emptyImage from "assets/images/imgs/empty_img.png";
import { useSnackbar } from "contexts/SnackbarContext";

import "assets/scss/components/locationCard.scss";

const LocationCard = ({ loc, selectedSport, onClickFunc }) => {
    const { showSuccess, showError } = useSnackbar();
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div
                className="location-card-wrap"
                onClick={() => onClickFunc(loc)}
            >
                <div className="card-image">
                    <img
                        src={loc.image_url ? loc.image_url : emptyImage}
                        alt={loc.name}
                    />
                </div>
                <div className="location-info">
                    <h3>{loc.name}</h3>
                    <div className="address-container">
                        <span className="address">{loc.address}</span>
                        <button
                            className="copy-button"
                            onClick={(e) => {
                                copyText(e, loc.address);
                                showSuccess("주소가 복사되었습니다.");
                            }}
                        >
                            복사
                        </button>
                    </div>
                    <p
                        className="detail"
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowModal(true);
                        }}
                    >
                        자세히 보기
                    </p>
                </div>
            </div>
            {showModal && (
                <CommonModal
                    isOpen={showModal}
                    onRequestClose={() => setShowModal(false)}
                    className={`location-modal-wrap`}
                >
                    <LocationDetail info={loc} selectedSport={selectedSport} />
                </CommonModal>
            )}
        </>
    );
};

export default LocationCard;
